import React from 'react'
import { useData } from "../../utility/use-data";

const NewsLine = props => {
  return (
    <li>
      <p className="small">
        {`${props.date} / `}
        <a href={`/news/${props.id}`} className="in-text" target="_blank">{props.name}</a>
      </p>
    </li>
  )
}

export const NewsLineContainer = (props) => {
  const { id } = props;

  const initialData = (window.__SSRDATA && window.__SSRDATA[`_news_${id}`]) || null;
  const { result, state, error } = useData(
    "/api/news/" + id,
    0,
    initialData
  );
  const isLoading = state == "PENDING";

  if (isLoading || error) return null
  return <NewsLine {...result} />
};

